module.exports = __webpack_public_path__ + "img/mvp_add_user.4977c666.png";